import React from "react";
import PropTypes from "prop-types";
import firebase from "firebase";
import AddFishForm from "./AddFishForm";
import EditFishForm from "./EditFishForm";
import Login from "./Login";
import base, { firebaseApp } from "../base";

class Inventory extends React.Component {

    static propTypes = {
        fishes: PropTypes.object,
        updateFish: PropTypes.func,
        deleteFish: PropTypes.func,
        loadSampleFishes: PropTypes.func
    };

    // this is state in Invenotry only, used below
    state = {
        uid: null,
        owner: null
    };

    // this checks to see if user is logged in
    componentDidMount() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.authHandler({ user });
            }
        });
    }

    authHandler = async authData => {
        // 1 .Look up the current store in the firebase database
        // the "await" is so it does not just pass a "promise" << look up what that means
        // see App.js inventory section for where soreId comes from
        const store = await base.fetch(this.props.storeId, { context: this });
        console.log(store);

        // 2. Claim it if there is no owner
        if (!store.owner) {
            // save it as our own
            await base.post(`${this.props.storeId}/owner`, {
                data: authData.user.uid
            });
        }
        // 3. Set the state of the inventory component to reflect the current user
        // now this setting state for Invenory only, you can do that for components
        this.setState({
            // who is the current logged-in user?
            uid: authData.user.uid,
            // who is the owner of the store?
            owner: store.owner || authData.user.uid
        });
    };

    authenticate = provider => {
       //alert(provider);
       // normally might to this:
       // const authProvider = new firebase.auth.TwitterAuthProvider();
       // but we have 3 choices so....
       const authProvider = new firebase.auth[`${provider}AuthProvider`]();
       firebaseApp
           .auth()
           .signInWithPopup(authProvider)
           .then(this.authHandler);
    };

    logout = async () => {
        console.log("Logging out!");
        await firebase.auth().signOut();
        this.setState({ uid: null });
    };

    render() {

        const logout = <button onClick={this.logout}>Log Out!</button>;

        // Logic to show invenroty or not:
        // 1. Check if they are logged in
        if (!this.state.uid) {
            return <Login authenticate={this.authenticate} />;
        }
        // 2. check if they are not the owner of the store
        if (this.state.uid !== this.state.owner) {
            return (
                <div>
                    <p>Sorry you are not the owner!</p>
                    {logout}
                </div>
            );
        }
        // 3. They must be the owner, so go ahead and render the inventory

        // comments from previous chapters:
        // the addFish={this.props.addFish} is getting the addFish from Inventory and passing to AddFishForm
        // note here is it addFish={this.props.addFish} whereas in App is was addFish={this.addFish} when
        // adding to Inventory because in App it is a method, in Inventory it is a prop
        // so the addFish gets passed: App to Inventory to AddFishForm
        // ditto for the loadSampleFishes (from chapter 14)
        return (
            <div className="inventory">
                <h2>Inventory</h2>
                {logout}
                {Object.keys(this.props.fishes).map(key => (
                <EditFishForm
                    key={key}
                    index={key}
                    fish={this.props.fishes[key]}
                    updateFish={this.props.updateFish}
                    deleteFish={this.props.deleteFish}
                />
                ))}
                <AddFishForm addFish={this.props.addFish} />
                <button onClick={this.props.loadSampleFishes}>Load Sample Fishes</button>
            </div>
        )
    }
}

export default Inventory;

// NOTES
//
// this loops over each fish to show the edit form:
// {Object.keys(this.props.fishes).map(key=> <EditFishForm/>)}




// WEBPACK FOOTER //
// ./src/components/Inventory.js